import { combineReducers } from 'redux'
import flashes from 'client/features/flashes/reducers'
import forms from 'client/features/form/reducers'
import session from 'client/features/session/reducers'
import client from 'client/features/client/reducers'
import reports from 'client/features/reports/reducers'
import users from 'client/features/users/reducers'
import progressBar from 'client/features/progressBar/reducers'

const rootReducer = combineReducers(
    {
        session,
        client,
        reports,
        flashes,
        users,
        progressBar,
        form: forms
    }
)

export default rootReducer


// WEBPACK FOOTER //
// ./src/client/core/reducers.js